import React from "react";
import { useState, useRef, useLayoutEffect } from "react";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInputValidate.jsx";
import CustomInput2 from "components/CustomInput/CustomInputValidate2.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import CustomRadio from "components/CustomRadio/CustomRadio";
import Button from "components/CustomButtons/Button.jsx";
import { clone, cloneJ, commatize, formatNumberWithCommas, handleError, isImage, parseFloatString, round2dec } from "../../../shared/utility";
import Table from "components/Table/Table";
import { Dialog, IconButton } from "@material-ui/core";
import Notification from "../../../components/Notification/Notification";
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Tooltip from '@material-ui/core/Tooltip';
import Datetime from "react-datetime";
import axios from 'store/axios/axios-crm';
import { moveRight, moveLeft } from "../../../shared/utility";
import {
	min1,
	required,
	no_letters,
	max50,
} from "shared/validation";
import { useEffect } from "react";
import NotificationAsk from "../../../components/Notification/NotificationAsk";
import { getUser } from "../../../shared/authValidation";
import { checkSpacesPermission } from "./PropertiesLogic";
import moment from "moment";
import FileUploader from "../../../components/FileUploader/FileUploader";
import BucketUploader from "../../../components/FileUploader/BucketUploader";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove
} from "react-sortable-hoc";

import ReorderIcon from "@material-ui/icons/Reorder";
import { data } from "../../ERTL/ERTLObj";
import CustomInputValid from "../../../components/CustomInput/CustomInputValid";
import CustomSimpleDialog from "../../../components/CustomDialog/CustomSimpleDialog";
import { website_property_primary_types, website_property_secondary_types } from "./PropertiesObj";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";
import CustomDialogWithContact from "components/CustomDialog/CustomDialogWithContact";
import Close from "@material-ui/icons/Close";
import CustomCheckbox from "../../../components/CustomCheckbox/CustomCheckbox";
import { TextField } from "@material-ui/core";
import HighlightsListInput from "../../../components/HighlightsListInput/HighlightsListInput";
import DialogContent from "@material-ui/core/DialogContent";

const GraySwitch = withStyles({
	switchBase: {
		color: "#f5f5f5",
		"&$checked": {
		transform: "translateX(18px)",
		color: "#fff"
		},
		"&$checked + $track": {
		backgroundColor: "#da2229",
		opacity: 1
		}
	},
	checked: {},
	track: {
		backgroundColor: "#dcdcdc",
		opacity: 1
	}
})(Switch);

const Thumb = ({ src, alt = "" }) => {
  if (!src) return null;

  return (
    <a
      href={src}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: "block", textDecoration: "none" }}
    >
      <div
        style={{
          width: "100%",
          height: 180,          // <-- set your uniform height here
          overflow: "hidden",
          borderRadius: 6,
          background: "#f3f3f3"
        }}
      >
        <img
          src={src}
          alt={alt}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",  // <-- makes them all same size, crops as needed
            display: "block"
          }}
        />
      </div>
    </a>
  );
};


export const PropertiesFormSpaces = (props) => {
	const { updateDataObj, dataObj, setMadeChanges, propertyUseTypes } = props;
	const marketingOnly = getUser('CRM marketing_only');
	const initialData = {
		total_sqft: "",
		price_per_sqft: "",
		unit_number_address: "",
		address: "",
		lease_type: "",
		flat_price: "",
		is_flat_price: "",
		use_type: "",
		use_type_other: "",
		vacant: "",
		date_available: "", // shown if vacant = no,
		monthly_amount: "",
		sub_lease: "",

		min_divisible: "",
		max_contigous: "",
		build_out: "",

		brochure: "",
		photos: [],
		additional_links: [],

		lease_rate_or_price: "",
		total_space_available: "", // SF Available
		property_type: "",
		secondary_use: "",
		is_second_generation: "",
		parking_ratio: "",
		gross_leaseable_area: "", // if for sale
		site_area: "", // if for sale

		sublease_has_own_page: "",
		sublease_page_title: "",
		sublease_page_subtitle: "",
		sublease_page_address: "",
		sublease_page_description: "",
		sublease_page_highlights: "",
		sublease_page_highlights2: "",
		sublease_page_features: "",
		sublease_page_brochure: "",
		sublease_page_asking_price: "",
		sublease_page_property_type: "",
		sublease_page_secondary_use: "",
		sublease_page_parking_ratio: "",
		sublease_page_google_maps_embed_code: "",
		sublease_page_additional_links: [],
		sublease_page_associates: []
	};

	const [openForm, setOpenForm] = useState(true);
	const [action, setAction] = useState("View");
	const [formData, setFormData] = useState(initialData);
	const [originalFormData, setOriginalFormData] = useState(initialData);
	const [index, setIndex] = useState(-1);
	const [openAskBeforeDelete, setOpenAskBeforeDelete] = useState(false);
	const [validSqft, setValidSqft] = useState(true);
	const [useTypes, setUseTypes] = useState([]);
	const [notification, setNotification] = useState('');
	const [vacationHasChangedFromNoToYes, setVacationHasChangedFromNoToYes] = useState(false);
	const [startSendingMarketing, setStartSendingMarketing] = useState(false);
	const [openedSubleaseAssociatePicker, setOpenedSubleaseAssociatePicker] = useState(false);
	const [askToDeleteSubleaseLink, setAskToDeleteSubleaseLink] = useState(null);

	const bottomRef = useRef(null);

	useEffect(() => {
		if (originalFormData.vacant === 'No' && formData.vacant === 'Yes') {
			setVacationHasChangedFromNoToYes(true);
		}
	}, [formData]);

	useEffect(() => {
        if (props.success_send_to_marketing && startSendingMarketing) {
            setNotification('illi Marketing has been notified');
            setStartSendingMarketing(false);
        }
    }, [startSendingMarketing, props.success_send_to_marketing]);

	useEffect(() => {
		console.log('propertyUse', propertyUseTypes);
		let useTypes = propertyUseTypes.unit_use_type ? propertyUseTypes.unit_use_type.concat([]).sort() : [];
		useTypes.push('Other');
		setUseTypes(useTypes);
	}, []);

	useEffect(() => {
		if (dataObj.spaces && dataObj.spaces.length > 0) {
			const first = clone(dataObj.spaces[0]);
			setFormData(first);
			setOriginalFormData(clone(first));
			setIndex(0);
			setAction("View");
		} else {
			setFormData(clone(initialData));
			setOriginalFormData(clone(initialData));
			setIndex(-1);
			setAction("Add");
		}
	}, [dataObj.id]);

	const renderElement = (field, label, validations, uppercase, isCurrency) => {
		return (
			<CustomInput
				value={formData[field]}
				label={label}
				onChange={(e) => {
					const newData = clone(formData);
					newData[field] = e.target.value;
					setFormData(newData);
				}}
				validate={validations}
				uppercase={uppercase ? true : false}
				isCurrency={isCurrency ? true : false}
				startAdornment={isCurrency ? '$' : ''}
			/>
		);
	};

	const checkValidity = () => {
		let passed = true;
		
		if (!formData.total_sqft) passed = false;
		if (!formData['is_flat_price']) {
			passed = false;
			
		} else {
			if (formData['is_flat_price'] === "Yes") {
				// Flat Price is required
				if (!formData.flat_price) passed = false;
			} else if (formData['is_flat_price'] === "No") {
				// Price per sqft is required
				if (!formData.price_per_sqft) passed = false;
			}
		}
		const unit_number_address = formData.unit_number_address ? formData.unit_number_address.trim() : "";
		if (dataObj.address_is_range === 'Yes' || dataObj.address2_is_range === 'Yes') {
			// Properties with ranges: On spaces. 
			// If there is a street address then unit number not required. 
			// It should be either or required, not both. 
			if (!formData.address && !formData.unit_number_address) {
				console.log('f1');
				passed = false;
			}

		} else {
			if (!unit_number_address) {
				console.log('f3');
				passed = false;
			}
		}
		return passed;
	};

	const PhotoDragHandle = SortableHandle(() => (
		<ReorderIcon
			style={{
			cursor: "grab",
			color: "#888",
			marginBottom: 10
			}}
		/>
	));

	const SortablePhotoItem = SortableElement(({ children }) => children);

	const SortablePhotoList = SortableContainer(({ items }) => { 
		const [inputVal, setInputVal] = useState('');	
		const [openModal, setOpenModal] = useState(null);
		const [openDeleteModal, setOpenDeleteModal] = useState(null);

	return (
		<GridContainer>
			{openDeleteModal !== null && <CustomSimpleDialog 
				no_ok_button={true}
				open={true}
				close={() => {
					setOpenDeleteModal(null);
				}}
				content={<>
					<h3>Are you sure?</h3>
					<p>Are you sure you want to remove this media file entry?</p>
					<Button
						className="mr-20"
						color="rose"
						onClick={() => {
							const newFormData = clone(formData);
							newFormData.photos = newFormData.photos.filter((aiff, xx) => {
								if (xx === openDeleteModal) {
									return false;
								}
								return true;
							});
							setFormData(newFormData);
							setOpenDeleteModal(null);
						}}
					>REMOVE</Button>
					<Button color="white" onClick={() => {
						setOpenDeleteModal(null);
					}}>
						CANCEL
					</Button>
				</>}
			/>}
			{openModal !== null && <CustomSimpleDialog 
					no_ok_button={true}
					open={true}
					close={() => {
						setOpenModal(null);
					}}
					content={<>
						<CustomInputValid 
							label="Enter Caption/Title"
							value={inputVal}
							onChange={(e) => {
								setInputVal(e.target.value);
							}}
							autoFocus={true}
						/>
						<Button
							color="rose"
							onClick={() => {
								const newFormData = clone(formData);
								newFormData.photos = newFormData.photos.map((aiff, xx) => {
									if (xx === openModal) aiff.caption = inputVal;
									return aiff;
								});
								setFormData(newFormData);
								setOpenModal(null);
							}}
						>SUBMIT</Button>
					</>}
				/>}

			{items.map((aif, x) => (
			<SortablePhotoItem key={`photo-${x}`} index={x}>
				<GridItem xs={4} sm={4} md={4}>
				<div
					style={{
					padding: 20,
					border: aif.file ? "1px solid black" : "1px solid #da3b2f",
					marginBottom: 20,
					background: "#fff"
					}}
				>
					<PhotoDragHandle />
						<IconButton
							style={{float:'right'}}
							onClick={() => {
								setOpenDeleteModal(x);
							}}
						>
							<i className="fa fa-trash red-text"></i>
						</IconButton>
					<hr />

					<CustomInput
					value={aif.caption || ""}
					label="Caption"
					onChange={(e) => {
						
					}}
					onClick={() => {
						setInputVal(aif.caption || "");
						setOpenModal(x);
					}}
					/>

					<BucketUploader
					has_alt={true}
					disabled={false}
					title={aif.file ? `Media File #${x + 1}` : ""}
					update={(val, alt) => {
						const newFormData = clone(formData);
						newFormData.photos = newFormData.photos.map((aiff, xx) => {
							if (xx === x) aiff.file = val;
							return aiff;
						});
						setFormData(newFormData);
					}}
					remove={() => {
						const newFormData = clone(formData);
						newFormData.photos = newFormData.photos.filter((_, xx) => xx !== x);
						setFormData(newFormData);
					}}
					the_filename={aif.file}
					the_alt={aif.alt}
					type="crm"
					canEdit={true}
					image_size_the_same={true}
					/>
				</div>
				</GridItem>
			</SortablePhotoItem>
			))}
		</GridContainer>
		)
	});


	const update = (field, value) => {
		const newData = clone(formData);
		newData[field] = value;
		setFormData(newData);
	}

	const addressMessage = (dataObj.address_is_range === 'Yes' || dataObj.address2_is_range === 'Yes') ? 
		!formData.address && !formData.unit_number_address ? 
			<span style={{color:'orange'}}>Street Address is required if there is no Unit Number</span> 
		:
			null
	: 
		null;
	const unitNumberMessage = (dataObj.address_is_range === 'Yes' || dataObj.address2_is_range === 'Yes') ?
			!formData.address && !formData.unit_number_address ? 
				<span style={{color:'orange'}}>Unit is Required if there is no Street Address</span>
			: 
				null
		:  
			!formData.unit_number_address ?
				<span style={{color:'red'}}>Unit is Required</span>
			:
				null;

	console.log('PropertiesFormSpaces', formData);

	const monthly_amount = round2dec(parseFloatString(formData.price_per_sqft) * parseFloatString(formData.total_sqft));

	const user = getUser();
	const userAllowedSpaces = checkSpacesPermission({user, property:dataObj})

	const saveSpace = async (obj) => {
		try {
			const response = await axios.put('/property', obj);
			console.log('response', response.data);
			setNotification('Saved the space');
		} catch(e) {
			setNotification('Could not save space, if the error persists please contact tech support')
			handleError(e);
		}
	}

	const [shouldScrollToBottom, setShouldScrollToBottom] = useState(false);

	const dialogBodyRef = useRef(null);

	const scrollDialogToTop = () => {
		dialogBodyRef.current?.scrollTo({
		top: 0,
		behavior: "smooth",
		});
	};

	useLayoutEffect(() => {
		if (!shouldScrollToBottom) return;

		const el = dialogBodyRef.current;
		if (!el) return;

		el.scrollTop = el.scrollHeight;

		setShouldScrollToBottom(false);
	}, [shouldScrollToBottom, formData.photos?.length]);

	const renderSpaces = () => {
		return <div
					ref={dialogBodyRef}
					className={(props.action === "View" || action === 'View') ? "no-click lightgray-bg enclosure" : "enclosure"}
					style={{ padding: 20 }}
				>
						<h3>{action} Space{action === "Edit" && dataObj.spaces && dataObj.spaces.length > 0 ? ` ${index + 1} of ${dataObj.spaces.length}` : ""}</h3>
						{<div className={marketingOnly ? "" : ""}><GridContainer>
							<GridItem xs={12} sm={3} md={3}>
								{renderElement("address", "Street Address")}
								{addressMessage}
							</GridItem>
							<GridItem xs={12} sm={3} md={3}>
								{renderElement("unit_number_address", "Space Address / Unit Number")}
								{unitNumberMessage}
							</GridItem>
							<GridItem xs={12} sm={3} md={3}>
								<CustomInput2
									value={formData["total_sqft"]}
									label={"Total Square Feet"}
									onChange={(e) => {
										const value = e.target.value || 0;

										const otherSpacesSqft = dataObj.spaces.reduce(
										(totalSpaceSqft, current, i) => {
											if (i === index) return totalSpaceSqft; // 👈 skip current space
											return totalSpaceSqft + (parseFloat(current.total_sqft) || 0);
										},
										0
										);

										const totalSpaceSqft = otherSpacesSqft + parseFloat(value) ;
										const totalBuildingSqft = dataObj.total_building_sqft ? parseFloat(dataObj.total_building_sqft) : 0;
										console.log('wcanready', totalSpaceSqft, totalBuildingSqft);
										if (totalSpaceSqft > totalBuildingSqft) {
											setValidSqft(false);
										} else {
											setValidSqft(true);
										}

										const newData = clone(formData);
										newData["total_sqft"] = e.target.value;
										setFormData(newData);
									}}
									validate={[
										min1,
										max50,
										required
									]}
									uppercase={false}
									isCurrency={true}
								/>
							</GridItem>
							<GridItem xs={12} sm={3} md={3}>
								<CustomInput
									value={formData.min_divisible}
									label="Min Divisible"
									onChange={(e) => {
										const newData = clone(formData);
										newData.min_divisible = e.target.value;
										setFormData(newData);
									}}
									number_only={true}
								/>
								<small>* Must be less or equal of total square feet of this space</small>
							</GridItem>
							<GridItem xs={12} sm={3} md={3}>
								<CustomInput
									value={formData.max_contigous}
									label="Max Contigous"
									onChange={(e) => {
										const newData = clone(formData);
										newData.max_contigous = e.target.value;
										setFormData(newData);
									}}
									number_only={true}
								/>
								<small>* Must be less or equal of property's total square feet</small>
							</GridItem>
							<GridItem xs={12} sm={3} md={3}>
								<CustomRadio
									label="Build Out,Yes,No"
									options={["Yes", "No"]}
									onChange={(e) => {
										const newData = clone(formData);
										newData.build_out = e.target.value;
										setFormData(newData);
									}}
									value={formData.build_out}
								/>
							</GridItem>

							<GridItem xs={12} sm={3} md={3}>
								<CustomRadio
									label="Price Type,Flat Price,Price Per Square Feet"
									options={["Yes", "No", ""]}
									onChange={(e) => {
										const newData = clone(formData);
										newData["is_flat_price"] = e.target.value;
										if (newData.is_flat_price) {
											// render Price per Sq Ft. blank
											newData.price_per_sqft = '';
										} else {
											// render Flat price blank
											newData.flat_price = '';
										}
										setFormData(newData);
									}}
									value={formData.is_flat_price}
								/>
								{!formData.is_flat_price && <div className="red-text">
										<small>Required</small>
									</div>}
							</GridItem>
							<GridItem xs={12} sm={3} md={3}>
								{formData['is_flat_price'] === "No" && <div>
									{renderElement("price_per_sqft", "Price Per Square Feet", [
										min1,
										max50
									], false, 'is_currency')}
									{!formData.price_per_sqft && <div className="red-text">
										<small>Required</small>
									</div>}
								</div>}
								{formData['is_flat_price'] === "Yes" && <div>
									{renderElement("flat_price", "Flat Price", [
										min1,
										max50
									], false, 'is_currency')}
									{!formData.flat_price && <div className="red-text">
										<small>Required</small>
									</div>}
								</div>}
							</GridItem>
							<GridItem xs={12} sm={3} md={3}>
								<div style={{opacity: formData.use_type === 'Residential' ? 0 : 1}}><CustomSelect
									label="Lease Type"
									choose={(e, n) => {
										const newData = clone(formData);
										newData["lease_type"] = e;
										if (e !== 'MG' && e !== 'NNN') {
											newData.monthly_amount = '';
										}
										setFormData(newData);
									}}
									options={props.propertyUseTypes.lease_type}
                                    default={formData['lease_type']}
								/>
									<CustomRadio
										label="Sub Lease,Yes,No"
										options={["Yes", "No"]}
										onChange={(e) => {
											const newData = clone(formData);
											newData.sub_lease = e.target.value;
											setFormData(newData);
										}}
										value={formData.sub_lease}
									/>
								</div>
							</GridItem>
							<GridItem xs={12} sm={3} md={3}>
								{(formData.lease_type === 'MG' || formData.lease_type === 'NNN') && <CustomInput
									value={formatNumberWithCommas(formData.monthly_amount)}
									label={`${formData.lease_type} Monthly Amount`}
									onChange={(e) => {
										let value = e.target.value;

										// Remove commas
										value = value.replace(/,/g, '');

										// Allow only numbers and decimal
										value = value.replace(/[^0-9.]/g, '');

										// Prevent multiple decimals
										const parts = value.split('.');
										if (parts.length > 2) {
											value = parts[0] + '.' + parts.slice(1).join('');
										}
										if (!value) {
											if (value != 0) {
												return;
											}
										}
										const newData = clone(formData);
										newData.monthly_amount = value;
										setFormData(newData);
									}}
									isCurrency={true}
									startAdornment='$'
								/>}
								{/* <CustomSelect
									label="Use Type"
									choose={(e, n) => {
										const newData = clone(formData);
										newData["use_type"] = e;
										if (e === 'Residential') {
											newData["lease_type"] = '';
										}
										setFormData(newData);
									}}
									options={useTypes}
                                    default={formData['use_type']}
								/> */}
							</GridItem>
							{formData["use_type"] === "Other" && (
								<GridItem xs={12} sm={3} md={3}>
									{renderElement("use_type_other", "Use Type - Other", [required])}
								</GridItem>
							)}
							<GridItem xs={12} sm={3} md={3}>
								<CustomRadio
									label="Vacant,Yes,No"
									options={["Yes", "No"]}
									onChange={(e) => {
										const newData = clone(formData);
										newData["vacant"] = e.target.value;
										if (e.target.value === 'No') {
											newData.date_available = '';
										}
										setFormData(newData);
									}}
									value={formData.vacant}
								/>
								{formData.vacant === "No" && <div>
								<div className="custom relative">
									{formData.date_available && <div className="tiny-label">Date Available</div>}
									<Datetime
										inputProps={{
											placeholder: "Date Available",
										}}
										closeOnSelect={true}
										onChange={(e) => {
											if (typeof e === 'object') {
												const stringDate = e.format('MM/DD/YYYY');
												return update('date_available', stringDate);;
											}
											updateDataObj('date_available', e)
										}}
										timeFormat={false}
										value={formData.date_available}
									/>
								</div>
								</div>}
							</GridItem>
							{formData.sub_lease === "Yes" && <GridItem xs={12} sm={12} md={12}>
								<div className="boxed">
									<FormControlLabel
										label="This subleased space has its own page on the illi website"
										control={
											<GraySwitch
												checked={formData.sublease_has_own_page === "Yes"}
												onChange={(e) => {
													const newData = clone(formData);
													newData.sublease_has_own_page = e.target.checked ? "Yes" : "";
													setFormData(newData);
												}}
											/>
										}
									/>
									{formData.sublease_has_own_page === "Yes" && <div style={{marginTop:20}}>
										<h4>Sublease Website Page</h4>
										<GridContainer>
											<GridItem xs={12} sm={6} md={6}>
												<CustomInput
													value={formData.sublease_page_title}
													label="Page Title"
													onChange={(e) => {
														const newData = clone(formData);
														newData.sublease_page_title = e.target.value;
														setFormData(newData);
													}}
												/>
											</GridItem>
											<GridItem xs={12} sm={6} md={6}>
												<CustomInput
													value={formData.sublease_page_subtitle}
													label="Page Subtitle"
													onChange={(e) => {
														const newData = clone(formData);
														newData.sublease_page_subtitle = e.target.value;
														setFormData(newData);
													}}
												/>
											</GridItem>
											<GridItem xs={12} sm={12} md={12}>
												<CustomInput
													value={formData.sublease_page_address}
													label="Page Address"
													onChange={(e) => {
														const newData = clone(formData);
														newData.sublease_page_address = e.target.value;
														setFormData(newData);
													}}
												/>
											</GridItem>
											<GridItem xs={12} sm={12} md={12}>
												<TextField
													label="Property Description"
													multiline
													rows={4}
													margin="normal"
													value={formData.sublease_page_description || ''}
													onChange={(e) => {
														const newData = clone(formData);
														newData.sublease_page_description = e.target.value;
														setFormData(newData);
													}}
													style={{width:'100%'}}
												/>
											</GridItem>
											<GridItem xs={12} sm={6} md={6}>
												<HighlightsListInput
													label="Highlights (Column 1)"
													value={formData.sublease_page_highlights}
													onChange={(val) => {
														const newData = clone(formData);
														newData.sublease_page_highlights = val;
														setFormData(newData);
													}}
												/>
											</GridItem>
											<GridItem xs={12} sm={6} md={6}>
												<HighlightsListInput
													label="Highlights (Column 2)"
													value={formData.sublease_page_highlights2}
													onChange={(val) => {
														const newData = clone(formData);
														newData.sublease_page_highlights2 = val;
														setFormData(newData);
													}}
												/>
											</GridItem>
											<GridItem xs={12} sm={6} md={6}>
												<h4>Features</h4>
												{[
													'Air Conditioning',
													'Balcony',
													'Controlled Access',
													'Fenced Lot',
													'Signage',
													'Outdoor Seating',
													'Reception',
													'Restaurant',
													'Security System',
													'Storage Space'
												].map((fo, foi) => {
													const featuresStr = formData.sublease_page_features || '';
													const checked = featuresStr.split(',').indexOf(fo) !== -1;
													return <CustomCheckbox
														key={`subfeat-${foi}`}
														checked={checked ? true : false}
														onChange={() => {
															const newData = clone(formData);
															let arr = (newData.sublease_page_features || '').split(',').filter(x => x);
															if (checked) {
																arr = arr.filter(f => f !== fo);
															} else {
																arr.push(fo);
															}
															newData.sublease_page_features = arr.join(',');
															setFormData(newData);
														}}
														label={fo}
													/>
												})}
											</GridItem>
											<GridItem xs={12} sm={6} md={6}>
												<BucketUploader
													disabled={false}
													title="Property Brochure"
													update={(val) => {
														const newData = clone(formData);
														newData.sublease_page_brochure = val;
														setFormData(newData);
													}}
													remove={() => {
														const newData = clone(formData);
														newData.sublease_page_brochure = '';
														setFormData(newData);
													}}
													the_filename={formData.sublease_page_brochure}
													type="crm"
													canEdit={true}
													show_image={true}
												/>
											</GridItem>
											<GridItem xs={12} sm={12} md={12}>
												<hr />
												<h4>PROPERTY FACTS</h4>
											</GridItem>
											<GridItem xs={12} sm={4} md={4}>
												<CustomInput
													label="Asking Price"
													value={formData.sublease_page_asking_price || ''}
													onChange={(e) => {
														let value = e?.target?.value ?? e ?? '';
														value = value.replace(/[^0-9.]/g, '');
														const parts = value.split('.');
														if (parts.length > 2) {
															value = parts[0] + '.' + parts.slice(1).join('');
														}
														const newData = clone(formData);
														newData.sublease_page_asking_price = value;
														setFormData(newData);
													}}
													isDollar={true}
													is_dollar={true}
												/>
											</GridItem>
											<GridItem xs={12} sm={4} md={4}>
												<CustomSelect
													default={formData.sublease_page_property_type}
													options={website_property_primary_types}
													label="Property Type"
													choose={(e) => {
														const newData = clone(formData);
														if (e !== newData.sublease_page_property_type) {
															newData.sublease_page_secondary_use = '';
														}
														newData.sublease_page_property_type = e;
														setFormData(newData);
													}}
												/>
												<CustomSelect
													default={formData.sublease_page_secondary_use}
													options={website_property_secondary_types[formData.sublease_page_property_type] ? website_property_secondary_types[formData.sublease_page_property_type] : []}
													label="Secondary Use"
													choose={(e) => {
														const newData = clone(formData);
														newData.sublease_page_secondary_use = e;
														setFormData(newData);
													}}
												/>
											</GridItem>
											<GridItem xs={12} sm={4} md={4}>
												<CustomInput
													label="Parking Ratio"
													value={formData.sublease_page_parking_ratio || ''}
													onChange={(e) => {
														const newData = clone(formData);
														newData.sublease_page_parking_ratio = e.target.value;
														setFormData(newData);
													}}
												/>
											</GridItem>
											<GridItem xs={12} sm={4} md={4}>
												<TextField
													label="Enter Google Maps Embed Code"
													multiline
													rows={4}
													variant="outlined"
													fullWidth
													value={formData.sublease_page_google_maps_embed_code || ''}
													onChange={(e) => {
														const newData = clone(formData);
														newData.sublease_page_google_maps_embed_code = e.target.value;
														setFormData(newData);
													}}
												/>
											</GridItem>
											<GridItem xs={12} sm={12} md={12}>
												<hr />
												<h4>Additional Links</h4>
												<Button color="primary" onClick={() => {
													const newData = clone(formData);
													const links = newData.sublease_page_additional_links || [];
													newData.sublease_page_additional_links = [{ url: '', description: '' }, ...links];
													setFormData(newData);
												}}>ADD LINK</Button>
												{askToDeleteSubleaseLink !== null && <NotificationAsk
													title="Are you sure?"
													content={<p>Do you want to remove this additional link?</p>}
													success={() => {
														const newData = clone(formData);
														newData.sublease_page_additional_links = (newData.sublease_page_additional_links || []).filter((_, i) => i !== askToDeleteSubleaseLink);
														setFormData(newData);
														setAskToDeleteSubleaseLink(null);
													}}
													open={true}
													close={() => { setAskToDeleteSubleaseLink(null); }}
												/>}
												{(formData.sublease_page_additional_links || []).map((adl, indx) => {
													const links = formData.sublease_page_additional_links || [];
													return <div className="boxed mt-20" key={`subadl-${indx}`}>
														<IconButton
															onClick={() => { setAskToDeleteSubleaseLink(indx); }}
															className="mr-20"
														>
															<i className="red-text fa fa-trash"></i>
														</IconButton>
														<IconButton
															disabled={indx === 0}
															onClick={() => {
																if (indx === 0) return;
																const newData = clone(formData);
																const items = newData.sublease_page_additional_links;
																const tmp = items[indx];
																items[indx] = items[indx - 1];
																items[indx - 1] = tmp;
																setFormData(newData);
															}}
															className="mr-20"
														>
															<i className="fa fa-chevron-up"></i>
														</IconButton>
														<IconButton
															disabled={indx === links.length - 1}
															onClick={() => {
																if (indx >= links.length - 1) return;
																const newData = clone(formData);
																const items = newData.sublease_page_additional_links;
																const tmp = items[indx];
																items[indx] = items[indx + 1];
																items[indx + 1] = tmp;
																setFormData(newData);
															}}
															className="mr-20"
														>
															<i className="fa fa-chevron-down"></i>
														</IconButton>
														<CustomInput
															label="URL / Link"
															value={adl.url || ''}
															onChange={(e) => {
																const newData = clone(formData);
																newData.sublease_page_additional_links[indx].url = e.target.value;
																setFormData(newData);
															}}
														/>
														<CustomInput
															label="Label"
															value={adl.description || ''}
															onChange={(e) => {
																const newData = clone(formData);
																newData.sublease_page_additional_links[indx].description = e.target.value;
																setFormData(newData);
															}}
														/>
													</div>
												})}
											</GridItem>
											<GridItem xs={12} sm={12} md={12}>
												<hr />
												<h4>{(formData.sublease_page_associates || []).length} Associate(s) on this page</h4>
												<Button
													color="primary"
													style={{marginBottom:20}}
													onClick={() => {
														setOpenedSubleaseAssociatePicker(true);
													}}
												>
													<i className="fa fa-plus"></i> Add Associate
												</Button>
												<Table
													tableHeaderColor="primary"
													tableHead={["Name", "Email", "Remove"]}
													tableData={(formData.sublease_page_associates || []).map((a, ai) => {
														const cd = a.contact_data || {};
														const name = `${cd.first_name || ''} ${cd.last_name || ''}`.trim();
														return [
															name || `Contact #${a.contact_id}`,
															cd.email || '',
															<IconButton
																className="red-text"
																onClick={() => {
																	const newData = clone(formData);
																	newData.sublease_page_associates = (newData.sublease_page_associates || []).filter((_, j) => j !== ai);
																	setFormData(newData);
																}}
															><Close /></IconButton>
														];
													})}
												/>
											</GridItem>
										</GridContainer>
									</div>}
								</div>
								{openedSubleaseAssociatePicker && <CustomDialogWithContact
									open={openedSubleaseAssociatePicker}
									close={() => { setOpenedSubleaseAssociatePicker(false); }}
									choose={(the_contact_data) => {
										const newData = clone(formData);
										const existing = newData.sublease_page_associates || [];
										if (!existing.find(e => e.contact_id === the_contact_data.id)) {
											existing.push({
												contact_id: the_contact_data.id,
												contact_data: the_contact_data,
												connect_user_id: the_contact_data.connect_user_id
											});
										}
										newData.sublease_page_associates = existing;
										setFormData(newData);
										setOpenedSubleaseAssociatePicker(false);
									}}
									create_and_choose={(the_contact_data) => {
										const newData = clone(formData);
										const existing = newData.sublease_page_associates || [];
										existing.push({
											contact_id: the_contact_data.id,
											contact_data: the_contact_data,
											connect_user_id: the_contact_data.connect_user_id
										});
										newData.sublease_page_associates = existing;
										setFormData(newData);
										setOpenedSubleaseAssociatePicker(false);
									}}
									peopleType="agents"
									title="Select Associate"
									label="Search Contacts"
								/>}
							</GridItem>}
							<GridItem xs={12} sm={12} md={12}>

								<div className="boxed">
									<h4>illicre.com Space Listing Property Facts</h4>
									{/* <GridItem xs={12} sm={4} md={4}>
										<CustomInput
											value={formData.lease_rate_or_price}
											label="Lease Rate or Price"
											onChange={(e) => {
												const newData = clone(formData);
												newData.lease_rate_or_price = e.target.value;
												setFormData(newData);
											}}
										/>
									</GridItem> */}
								  <GridContainer>
									<GridItem xs={12} sm={4} md={4}>
										<FormControlLabel
											label="Is this space Second-Generation?"
											control={
												<GraySwitch
												checked={formData.is_second_generation === "Yes"}
												onChange={(e) => {
													const newData = clone(formData);
													newData.is_second_generation = e.target.checked ? "Yes" : "";
													setFormData(newData);
												}}
												/>
											}
											/>
									</GridItem>
									<GridItem xs={12} sm={4} md={4}>
										<CustomSelect 
											default={formData.property_type}
											options={website_property_primary_types}
											label="Property Type"
											choose={(e, n) => {
												const newData = clone(formData);
												newData.property_type = e;
												setFormData(newData);
											}}
										/>
										<CustomSelect 
											default={formData.secondary_use}
											options={website_property_secondary_types[formData.property_type] ? website_property_secondary_types[formData.property_type] : []}
											label="Secondary Use"
											choose={(e, n) => {
												const newData = clone(formData);
												newData.secondary_use = e;
												setFormData(newData);
											}}
										/>
									</GridItem>
									
									<GridItem xs={12} sm={4} md={4}>
										<CustomInput
											value={formData.parking_ratio}
											label="Parking Ratio"
											onChange={(e) => {
												const newData = clone(formData);
												newData.parking_ratio = e.target.value;
												setFormData(newData);
											}}
										/>
									</GridItem>
									{/* <GridItem xs={12} sm={4} md={4}>
										<CustomInput
											value={formData.gross_leaseable_area}
											label="Gross Leasable Area (if for sale)"
											onChange={(e) => {
												const newData = clone(formData);
												newData.gross_leaseable_area = e.target.value;
												setFormData(newData);
											}}
										/>
									</GridItem> */}
									{/* <GridItem xs={12} sm={4} md={4}>
										<CustomInput
											value={formData.site_area}
											label="Site Area (if for sale)"
											onChange={(e) => {
												const newData = clone(formData);
												newData.site_area = e.target.value;
												setFormData(newData);
											}}
										/>
									</GridItem> */}
									<GridItem xs={12} sm={4} md={4}></GridItem>
									<GridItem xs={12} sm={12} md={12}>
										<hr />
										<h4>ASKING RATE</h4>
									</GridItem>
									<GridItem xs={12} sm={4} md={4}>
										<CustomRadio
											label="Asking Price Type,Flat Price,Price Per Square Feet"
											options={["Flat Price", "Price Per Square Feet", ""]}
											onChange={(e) => {
												const newData = clone(formData);
												newData["asking_price_type"] = e.target.value;
												if (newData.asking_price_type === 'Price Per Square Feet') {
													// render Flat price blank
													newData.asking_flat_price = '';
												} else if (newData.asking_price_type === 'Flat Price') {
													// render Price per Sq Ft. blank
													newData.asking_price_per_sqft = '';
												}
												setFormData(newData);
											}}
											value={formData.asking_price_type}
										/>
									</GridItem>
									<GridItem xs={12} sm={4} md={4}>
										{formData.asking_price_type === 'Price Per Square Feet' ? renderElement("asking_price_per_sqft", "Asking Price Per Sq.ft.", [
										min1,
										max50
										], false, 'is_currency') : null}

										{formData.asking_price_type === 'Flat Price' ? renderElement("asking_flat_price", "Asking Flat Price", [
										min1,
										max50
										], false, 'is_currency') : null}
									</GridItem>
								  </GridContainer>
								</div>
							</GridItem>
						</GridContainer></div>}
						<GridContainer>
							<GridItem xs={12} sm={12} md={12}>
								<div className="boxed mt-20">
									<BucketUploader
										disabled={false}
										title="Space Brochure"
										update={(val, alt) => {
											const newFormData = clone(formData);
											newFormData.brochure = val;
											setFormData(newFormData)
										}}
										remove={() => {
											const newFormData = clone(formData);
											newFormData.brochure = '';
											setFormData(newFormData)
										}}
										the_filename={formData.brochure}
										type="crm"
										canEdit={true}
										show_image={true}
									/>
								</div>
							</GridItem>
							<GridItem xs={12} sm={12} md={12}>
								<h3>Space Documents</h3>
								<Button color="rose" onClick={() => {
									const newFormData = clone(formData);
									if (!formData.photos) {
										newFormData.photos = [];
									}
									newFormData.photos.push({
										file: '',
										alt: ''
									});
									setFormData(newFormData);
									setShouldScrollToBottom(true);
								}}>ADD MEDIA FILE</Button>
									{formData.photos && <GridContainer>
										<SortablePhotoList
											items={formData.photos}
											useDragHandle
											axis="xy"
											distance={6}
											helperClass="dragging"
											onSortEnd={({ oldIndex, newIndex }) => {
												if (oldIndex === newIndex) return;

												const newFormData = clone(formData);
												newFormData.photos = arrayMove(
												newFormData.photos,
												oldIndex,
												newIndex
												);
												setFormData(newFormData);
											}}
											/>
											<div ref={bottomRef} />
									</GridContainer>}
							</GridItem>
							
						</GridContainer>
						<p>Total building square feet: {commatize(parseFloatString(dataObj.total_building_sqft))}</p>
						<hr />
						<p className={`${!validSqft ? 'error-message' : ''}`}>* Total spaces' square feet cannot exceed total building square feet.</p>
						{action === "Add" && (
							<Button
								color="success"
								className="mr-20"
								onClick={() => {
									if (checkValidity()) {
										setMadeChanges(true)
										const newData = cloneJ(formData);
										if (newData.is_flat_price === 'Yes') {
											newData.monthly_amount = "";
										} else {
											// per Erick
											// if (newData.lease_type !== 'NNN') {
											// 	newData.monthly_amount = parseFloatString(newData.price_per_sqft) * parseFloatString(newData.total_sqft);
											// }
										}
										const user = getUser();
										newData.user_id = user.id;
										newData.user_name = user.name;
										newData.user_date_created = moment().format('MM/DD/YYYY HH:mm');
										newData.user_date_modified = moment().format('MM/DD/YYYY HH:mm');
										if ((userAllowedSpaces && 
											user.type === 'A' && 
											dataObj.user_id !== user.id) && 
											dataObj.id &&
											props.action === 'View'
										) {
											saveSpace({
												id: dataObj.id,
												spaces: JSON.stringify(dataObj.spaces.concat([clone(newData)]))
											});
										}
										const newDataObj = dataObj.spaces.concat([clone(newData)]);
										updateDataObj(
											"spaces",
											newDataObj
										);
										// setOpenForm(false);
										setAction('Edit');
										setIndex(newDataObj.length - 1);
									} else {
										alert('Please check for missing required fields');
									}
								}}
								disabled={!validSqft}
							>
								ADD
							</Button>
						)}
						{action === "Edit" && (
							<Button
								color="primary"
								className="mr-20"
								onClick={() => {
									if (checkValidity()) {
										// check if able to edit
										const user = getUser();
										// check if Agent and property is an illi property
										if (user.type === 'A' && dataObj.user_id === 1) {
											// check if current space creator is the user
											if (formData.user_id !== user.id) {
												return alert('You are not authorized to edit this space');
											}
										}

										setMadeChanges(true);

										const newDataObj = clone(dataObj);
										newDataObj.spaces = dataObj.spaces.map((dr, j) => {
											if (j === index) {
												const newData = cloneJ(formData);
												if (newData.is_flat_price === 'Yes') {
													newData.monthly_amount = "";
												} else {
													// per Erick
													// if (newData.lease_type !== 'NNN') {
													// 	newData.monthly_amount = parseFloatString(newData.price_per_sqft) * parseFloatString(newData.total_sqft);
													// }
												}
												newData.user_date_modified = moment().format('MM/DD/YYYY HH:mm');
												return clone(newData);
											}
											return dr;
										});
										if ((userAllowedSpaces && 
											user.type === 'A' && 
											dataObj.user_id !== user.id) && 
											dataObj.id &&
											props.action === 'View'
										) {
											saveSpace({
												id: dataObj.id,
												spaces: JSON.stringify(newDataObj.spaces)
											});
										}
										props.setDataObj(newDataObj);
										scrollDialogToTop();
										setAction('View');
									} else {
										alert('Please check missing required fields');
									}
								}}
								disabled={!validSqft}
							>
								UPDATE
							</Button>
						)}

						{(props.action !== "View" && action !== 'Add' &&
							(userAllowedSpaces && user.type === 'A' && dataObj.user_id !== user.id)
						) && (
							<Button
								style={{marginRight:20}}
								color="danger"
								onClick={() => {
									// if (marketingOnly) return alert('Sorry you are not allowed to delete this space');
									// check
									if (user.type === 'A') {
										if (userAllowedSpaces) {
											if (s.user_id !== user.id) {
												return alert('Sorry, you are not allowed to delete this space');
											}
										}
									}
									setOpenAskBeforeDelete(true);
								}}
							>
								<i className="fas fa-trash"></i> DELETE
							</Button>
						)}

						{(props.action !== "View" && action !== 'Add' &&
							(userAllowedSpaces && user.type === 'E')
						) && (
							<Button
								style={{marginRight:20}}
								color="danger"
								onClick={() => {
									setOpenAskBeforeDelete(true);
								}}
							>
								<i className="fas fa-trash"></i> DELETE
							</Button>
						)}

						<Button
							color="white"
							onClick={() => {
								setAction('View');
							}}
						>
							CANCEL
						</Button>
					</div>
	}

	console.log('formsp', props);

	return (
		<div
			style={{ width: "100%" }}
			className={
				props.action === "View" ? 
					(userAllowedSpaces && user.type === 'A' && dataObj.user_id !== user.id) ? 
						"enclosure"
					:
						"enclosure"
				: 
					"enclosure"
			}
		>
			<GridContainer>
				<GridItem xs={12} sm={12} md={12}>
					<h3>
						{dataObj.spaces && dataObj.spaces.length
							? dataObj.spaces.length
							: 0}{" "}
						Space(s)
					</h3>
					{(props.action !== "View" || 
						(userAllowedSpaces && user.type === 'A' && dataObj.user_id !== user.id)
					) && (<>
						{userAllowedSpaces && <Button
							color="primary"
							onClick={() => {
								if (!dataObj.total_building_sqft) {
									return setNotification('Total Building Square Feet is required before you add a Space. Please enter one in the Main tab.');
								}
								setAction("Add");
								setFormData(clone(initialData));
								setOriginalFormData(clone(initialData));
								setIndex(-1);
								setOpenForm(true);
							}}
						>
							<i className="fas fa-plus"></i> ADD SPACE
						</Button>}
						</>
					)}
				</GridItem>
			</GridContainer>

			{openForm && dataObj.spaces && dataObj.spaces.length > 0 && (action === "Edit" || action === "View") && <div style={{marginBottom: 10, padding: "0 20px"}}>
				<Button
					color="white"
					disabled={index <= 0}
					onClick={() => {
						if (index <= 0) return;
						const newIndex = index - 1;
						const sp = clone(dataObj.spaces[newIndex]);
						setFormData(sp);
						setOriginalFormData(clone(sp));
						setIndex(newIndex);
					}}
				>
					<KeyboardArrowLeft /> Previous
				</Button>
				<span style={{margin: "0 12px", fontWeight: "bold"}}>
					Space {index + 1} of {dataObj.spaces.length} 

					{action !== 'Edit' && <Button style={{marginLeft:20}} onClick={() => {
						setAction("Edit");
					}}>EDIT</Button>}

				</span>
				<Button
					color="white"
					disabled={index >= dataObj.spaces.length - 1}
					onClick={() => {
						if (index >= dataObj.spaces.length - 1) return;
						const newIndex = index + 1;
						const sp = clone(dataObj.spaces[newIndex]);
						setFormData(sp);
						setOriginalFormData(clone(sp));
						setIndex(newIndex);
					}}
				>
					Next <KeyboardArrowRight />
				</Button>
			</div>}

			{openForm && action === "Add" && (
				<Dialog
					open={openForm}
					onClose={() => {
						setAction('Edit');
					}}
					maxWidth="lg"
					fullWidth
				>
					<DialogContent>
						{renderSpaces()}
					</DialogContent>
				</Dialog>
				)}

			{openForm && action !== "Add" && renderSpaces()}

			{openAskBeforeDelete && (
				<Dialog
					maxWidth="sm"
					fullWidth={true}
					open={openAskBeforeDelete}
					onClose={() => {
						setOpenAskBeforeDelete(false);
					}}
				>
					<GridContainer>
						<GridItem xs={12} sm={12} md={12}>
							<div className="dialog-wrapper text-center">
								<h4>Are you sure you want to delete this space?</h4>
								<Button
									color="danger"
									className="mr-20"
									onClick={() => {
										// associate with an illi property
										if (props.action === 'View') {
											if ((userAllowedSpaces && user.type === 'A' && dataObj.user_id !== user.id) && dataObj.id) {
												try {
													saveSpace({
														id: dataObj.id,
														spaces: JSON.stringify(dataObj.spaces.filter((ds, j) => {
															if (j === index) return false;
															return true;
														}))
													});
													if (index > 0) setIndex(index - 1);
												} catch(e) {
													handleError(e);
												}
											}
										}
										updateDataObj(
											"spaces",
											dataObj.spaces.filter((ds, j) => {
												if (j === index) return false;
												return true;
											})
										);
										props.setTab('Main');
										setTimeout(() => {
											props.setTab('Spaces');
											scrollDialogToTop();
										}, 1000);
										if (index > 0) setIndex(index - 1);
										setMadeChanges(true)
										setOpenAskBeforeDelete(false);
									}}
								>
									OK DELETE
								</Button>
								<Button
									color="white"
									onClick={() => {
										setOpenAskBeforeDelete(false);
									}}
								>
									CANCEL
								</Button>
							</div>
						</GridItem>
					</GridContainer>
				</Dialog>
			)}

			{notification && <Notification 
						open={notification ? true : false}
						close={() => {
							setNotification('');
						}}
						message={notification}
					/>}

			{vacationHasChangedFromNoToYes && <NotificationAsk 
				open={vacationHasChangedFromNoToYes ? true : false}
				close={() => {
					setVacationHasChangedFromNoToYes(false);
				}}
				title="Notify illi Marketing?"
				message="Send notification that vacancy info of this space has been updated?"
				success={() => {
					if (props.sendToMarketing) {
						setStartSendingMarketing(true);
						props.sendToMarketing({
							subject: 'illi Marketing Notification',
							message: `Property ${dataObj.name} has updated vacancy info.`
						});
						setVacationHasChangedFromNoToYes(false);
					}
				}}
				success_button_text="Send"
			/>}
		</div>

		
	);
};
